import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {
  @Input() width: string = '8rem';
  @Input() height: string = '1rem';
  @Input() bottomMargin: string = '0';
  @Input() topMargin: string = '0';
  @Input() centered: boolean = false;
  @Input() inline: boolean = false; // When used next to other text, adds horizontal margin.

  constructor() {}
}
